import InfiniteScroll from "react-infinite-scroller";

import Loading from "@/components/loadings/Loading";
import UserAvatar from "@/components/media/UserAvatar";
import { type User } from "@/types";
import { useFetchUsersInfinite } from "@/user/services";
import { getNameGroupLabel } from "@/utils";

import { useRecentSearchedUsers } from "../../hooks/useRecentSearchedUsers";
import MessengerCard from "../base/MessengerCard";

export default function UserList({
  onUserClick,
}: {
  onUserClick: (user: User<true>) => void;
}) {
  const { addRecentUser } = useRecentSearchedUsers();
  const {
    data: users,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFetchUsersInfinite({ order: "first_name", direction: "asc" });

  const handleContactClick = (user: User<true>) => {
    addRecentUser(user);
    onUserClick(user);
  };

  let prevLetter = "";

  return (
    <div className="h-full overflow-y-auto">
      <InfiniteScroll
        pageStart={0}
        loadMore={() => !isFetchingNextPage && fetchNextPage()}
        hasMore={hasNextPage}
        useWindow={false}
        className="flex flex-col"
        loader={<Loading key={0} className="my-2 self-center" size="sm" />}
      >
        {users?.pages?.map((page: any) =>
          page?.data?.map((user: User<true>) => {
            const letter = getNameGroupLabel(user.first_name?.[0] ?? "#");
            const showHeader = letter !== prevLetter;
            prevLetter = letter;

            return (
              <div key={user.id}>
                {showHeader && (
                  <div className="bg-gray-50 px-10 py-2 text-sm/5 font-medium text-gray-600">
                    {letter}
                  </div>
                )}
                <MessengerCard
                  image={<UserAvatar size="lg" user={user} disableTooltip />}
                  title={`${user.first_name} ${user.last_name}`}
                  subtitle={user.position?.name || "-"}
                  onClick={() => handleContactClick(user)}
                />
              </div>
            );
          }),
        )}
      </InfiniteScroll>
    </div>
  );
}
